<template>
  <div>
    <div v-if="title" class="text-h6 mb-3">{{ title }}</div>
    <v-form ref="form">
      <v-card v-for="(question, index) in questions" :key="question.id" class="rounded-card mb-4" flat outlined>
        <v-card-text>
          <div class="overline grey--text text--darken-1 mb-1">
            {{ $t('views.appraisals.show.questionLabel', { number: index + 1 }) }}
          </div>
          <div class="text-h6 font-weight-medium mb-3">
            {{ question.body }}
            <span v-if="showScores && question.isScored" class="body-2 grey--text text--darken-1 font-weight-regular">
              ({{ $t('models.appraisal.attributes.weightValue', { weight: question.weight }) }})
            </span>
          </div>

          <app-field v-if="question.questionType === questionTypes.FREE_TEXT" type="textarea" :label="answerLabel"
            v-model="localAnswers[question.id]" :rules="fieldRules" :disabled="readonly" hide-details />

          <v-radio-group v-else-if="question.questionType === questionTypes.MCQ"
            v-model="localAnswers[question.id]" :rules="radioRule"
            :disabled="readonly" class="mt-0" hide-details>
            <v-radio v-for="option in question.options" :key="option.id" :value="option.id">
              <template v-slot:label>
                <span>
                  {{ option.body }}
                  <span v-if="showScores && question.isScored" class="grey--text">({{ option.score }} pts)</span>
                </span>
              </template>
            </v-radio>
          </v-radio-group>

          <div v-if="errors[question.id]" class="error--text caption mt-1">{{ errors[question.id] }}</div>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import answerValidationMixin from './answerValidationMixin';

export default {
  name: 'AnswerSet',
  mixins: [answerValidationMixin],
  props: {
    value: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: true
    },
    showScores: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localAnswers: this.buildDefaultAnswers(this.value)
    };
  },
  computed: {
    fieldRules() {
      return this.readonly ? [] : this.requiredRule;
    },
    radioRule() {
      return this.readonly ? [] : [(value) => !!value];
    }
  },
  watch: {
    localAnswers: {
      deep: true,
      handler(answers) {
        this.$emit('input', answers);
        this.refreshErrors();
      }
    }
  },
  methods: {
    refreshErrors() {
      if (this.readonly || !this.hasAttemptedValidation) {
        return;
      }
      this.questions.forEach((question) => {
        this.$set(this.errors, question.id, this.isQuestionAnswered(question) ? '' : this.answerRequiredMessage);
      });
    }
  }
};
</script>
